import { Modal } from '@material-ui/core';
import React, { ReactElement } from 'react';
import './styles.scss';

interface FormModalProps {
	children: ReactElement;
	open: boolean;
	close: () => void;
}

const FormModal: React.FC<FormModalProps> = ({ children, open, close }) => {
	return (
		<Modal className="formModal" open={open} onClose={close}>
			<div className="formModal__wrapper">{children}</div>
		</Modal>
	);
};

export default FormModal;
